import { configureStore} from "@reduxjs/toolkit"
import mainPageSlice from "./mainPageReducer"

export const store = configureStore({
    reducer: {
        mainPage: mainPageSlice,
    },
})


